import React from "react";
import { QuestionItem } from "../../../types/form";
import {
  extractPhoneDigits,
  formatPhoneDisplay,
} from "../../../utils/usPhoneValidation";

interface PhoneFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
}

const PhoneFieldRenderer: React.FC<PhoneFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
}) => {
  const digits = extractPhoneDigits(currentValue);
  const display = formatPhoneDisplay(digits);

  return (
    <div className="space-y-1">
      <input
        type="tel"
        name={inputName}
        id={inputName}
        inputMode="tel"
        autoComplete="tel"
        className="border p-2 rounded-md w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 font-mono tracking-wide"
        placeholder={question.placeholder || "(555) 555-5555"}
        value={display}
        disabled={readOnly}
        aria-describedby={`${inputName}-phone-hint`}
        onChange={(e) => {
          const nextDigits = extractPhoneDigits(e.target.value).slice(0, 10);
          setFormData((prev) => ({
            ...prev,
            [inputName]: nextDigits,
          }));
        }}
      />
      <p
        id={`${inputName}-phone-hint`}
        className="text-xs text-gray-500"
      >
        Format: (XXX) XXX-XXXX (10 digits, U.S.)
      </p>
    </div>
  );
};

export default PhoneFieldRenderer;
